export default __webpack_public_path__ + "static/media/qr_code.510d83b1.svg";